import { localReadMessagesIds } from 'utils/localStorage';
import { sortMessagesByDate } from 'utils/sortMessagesByDate';

export const unreadMessages = ({ announcements }) => {
  const readMessagesIds = localReadMessagesIds();
  const unreadMessages =
    announcements.messages &&
    announcements.messages.filter(
      message => readMessagesIds.indexOf(message.id) === -1,
    );
  if (unreadMessages) return sortMessagesByDate(unreadMessages);
  return unreadMessages;
};

export const readMessages = ({ announcements }) => {
  const readMessagesIds = localReadMessagesIds();
  const readMessages =
    announcements.messages &&
    announcements.messages.filter(message =>
      readMessagesIds.includes(message.id),
    );
  if (readMessages) return sortMessagesByDate(readMessages);
  return readMessages;
};

export const announcementsVisible = ({ announcements }) =>
  announcements.announcementsVisible;
